<template>
  <div class="edit-order">
    <div class="step">
      <div class="prev-step">
        <mu-button color="primary" @click="prev" :disabled="activeStep === 0">
          <mu-icon left value="keyboard_arrow_left"></mu-icon>
          上一步
        </mu-button>
      </div>
      <mu-stepper :active-step="activeStep" class="stepper">
        <mu-step v-for="(item, index) in step" :key="index">
          <mu-step-label>
            {{ item }}
          </mu-step-label>
        </mu-step>
      </mu-stepper>
      <div class="next-step">
        <mu-button color="primary" @click="next" :disabled="activeStep === 4">
          <mu-icon left value="keyboard_arrow_right"></mu-icon>
          下一步
        </mu-button>
      </div>
    </div>
    <div class="step-wrapper" ref="scroll">
      <div class="scroll-wrapper">
        <!-- 客户信息 -->
        <div class="step-content customer">
          <mu-form :model="form" class="form" label-width="100">
            <mu-form-item label="客户">
              <mu-text-field
                v-model="form.customerStr"
                disabled
              ></mu-text-field>
            </mu-form-item>
            <!-- <mu-form-item>
              <mu-button color="primary" @click="createCustomer">添加新客户</mu-button>
            </mu-form-item> -->
          </mu-form>
        </div>
        <!-- 产品 -->
        <div class="step-content product">
          <mu-button
            fab
            color="red"
            class="add-button"
            @click="productOpen = true"
          >
            <mu-icon value="add"></mu-icon>
          </mu-button>
          <mu-data-table
            stripe
            :columns="productColumns"
            :data="form.products"
            class="table"
          >
            <template slot-scope="scope">
              <td class="is-center">{{ scope.$index + 1 }}</td>
              <td class="is-center">{{ scope.row.name }}</td>
              <td class="is-center">{{ scope.row.specification }}</td>
              <td class="is-center">{{ scope.row.price }}</td>
              <td class="is-center">{{ scope.row.count }}</td>
              <td class="is-center">{{ scope.row.sum }}</td>
              <td class="is-center">
                <img :src="scope.row.pic + '!product'" />
              </td>
              <td class="is-center">
                <mu-button color="info" @click="edit(scope.row)">
                  <mu-icon left value="edit" :size="20"></mu-icon>
                  编辑
                </mu-button>
                <mu-button color="secondary" @click="deleteOne(scope.row)">
                  <mu-icon left value="delete" :size="20"></mu-icon>
                  删除
                </mu-button>
              </td>
            </template>
          </mu-data-table>
        </div>
        <!-- 打印设计 -->
        <div class="step-content design">
          <mu-paper :z-depth="2" class="img-wrapper">
            <div class="title">待添加图片</div>
            <div class="img-list">
              <div
                class="img-item"
                v-for="(product, index) in form.products"
                :key="index"
                @click="addToDesign(product)"
              >
                <img :src="product.pic + '!product'" />
              </div>
            </div>
          </mu-paper>
          <mu-paper :z-depth="2" class="canvas-wrapper">
            <mu-button
              color="secondary"
              class="canvas-reset"
              @click="canvasReset"
              >重新添加</mu-button
            >
            <div class="title">打印区域</div>
            <div class="canvas">
              <canvas
                id="canvas"
                :width="mm2px(175)"
                :height="mm2px(220 - form.products.length * 6)"
              ></canvas>
            </div>
          </mu-paper>
        </div>
        <!-- 上传文件 -->
        <div class="step-content file">
          <div class="fileUpload">
            <mu-linear-progress
              color="green"
              :value="progress"
              class="progress"
              v-if="progress > 0"
              mode="determinate"
            ></mu-linear-progress>
            <div v-if="form.cadFileName">CAD文件：{{ form.cadFileName }}</div>
            <input
              type="file"
              ref="fileUpload"
              class="file-upload"
              accept=".dwg"
              @change="fileUpload"
            />
            <mu-button color="primary" @click="fileUploadClick">
              <mu-icon left value="cloud_upload" :size="20"></mu-icon>
              点击上传CAD文件
            </mu-button>
          </div>
        </div>
        <!-- 完成 -->
        <div class="step-content complete">
          <mu-paper :z-depth="2" class="info">
            <div class="info-item">
              <div class="title">客户：</div>
              <div class="desc">
                {{ form.customerStr }}
              </div>
            </div>
            <div class="info-item">
              <div class="title">产品：</div>
              <div class="desc"></div>
            </div>
            <div class="product-table">
              <table>
                <thead>
                  <tr>
                    <th>序号</th>
                    <th>名称</th>
                    <th>规格</th>
                    <th>单价</th>
                    <th>数量</th>
                    <th>总价</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in form.products" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.specification }}</td>
                    <td>{{ item.price }}</td>
                    <td>{{ item.count }}</td>
                    <td>{{ item.sum }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="info-item">
              <div class="title">总价：</div>
              <div class="desc">
                {{ form.sum }}
              </div>
            </div>
            <div class="info-item">
              <div class="title">文件：</div>
              <div class="desc">
                {{ form.cadFileName }}
              </div>
            </div>
          </mu-paper>
          <mu-button
            color="success"
            @click="submit"
            class="submit-button"
            v-loading="submitLoading"
            >确定修改</mu-button
          >
        </div>
      </div>
    </div>
    <NewCustomer
      :open.sync="customerOpen"
      @finish="getAllCustomer"
    ></NewCustomer>
    <NewProduct
      :open.sync="productOpen"
      @finish="newProductFinish"
    ></NewProduct>
    <UpdateProduct
      :open.sync="productEditOpen"
      :form="productEditForm"
      @finish="updateProductFinish"
    ></UpdateProduct>
  </div>
</template>

<script>
import { fabric } from 'fabric'
import BScroll from 'better-scroll'
import backend from 'utils/backend'
import api from '@/api'
import NewCustomer from './../customer/create'
import NewProduct from './../product/create'
import UpdateProduct from './../product/update'
import numeral from 'numeral'
let canvas = null
let scroll = null
let canvasData = null
export default {
  components: { NewCustomer, NewProduct, UpdateProduct },
  data() {
    return {
      step: ['客户信息', '产品', '打印设计', '上传文件', '完成'],
      activeStep: 0,
      allCustomer: [],
      form: {
        customerStr: '',
        customer: {},
        products: [],
        pdfData: [],
        sum: 0,
        cadFile: '',
        cadFileName: ''
      },
      progress: 0,
      customerOpen: false,
      productOpen: false,
      productEditOpen: false,
      productEditForm: {},
      productColumns: [
        {
          title: '序号',
          name: 'index',
          align: 'center'
        },
        {
          title: '名称',
          name: 'name',
          align: 'center'
        },
        {
          title: '规格',
          name: 'specification',
          align: 'center'
        },
        {
          title: '单价',
          name: 'price',
          align: 'center'
        },
        {
          title: '数量',
          name: 'count',
          align: 'center'
        },
        {
          title: '总价',
          name: 'sum',
          align: 'center'
        },
        {
          title: '图片',
          name: 'pic',
          align: 'center',
          width: 248
        },
        {
          title: '操作',
          align: 'center',
          width: 300
        }
      ],
      submitLoading: false
    }
  },
  methods: {
    // 刷新
    getAll() {},
    getOrderData() {
      const id = this.$route.query.id
      backend(api.order.getOrderData, { id }).then((result) => {
        if (result.statusCode === 200) {
          this.form = result.data
          this.form.customerStr =
            result.data.customer.company + ' - ' + result.data.customer.realName
          canvasData = {
            version: '2.7.0',
            objects: JSON.parse(JSON.stringify(result.data.pdfData))
          }
          this.activeStep = 1
        }
      })
    },
    createCustomer() {
      this.customerOpen = true
    },
    prev() {
      this.activeStep--
    },
    next() {
      this.activeStep++
    },
    getAllCustomer() {
      backend(api.user.getAll, { getAll: true, isCustomer: true }).then(
        (result) => {
          if (result.statusCode === 200) {
            this.allCustomer = result.data.rows
          }
        }
      )
    },
    edit(item) {
      this.productEditForm = item
      this.productEditOpen = true
    },
    deleteOne(item) {
      this.$confirm('确定要删除？', '提示', {
        type: 'warning'
      }).then(({ result }) => {
        if (result) {
          backend(api.product.delete, { id: item.id }).then((result) => {
            if (result.statusCode === 200) {
              this.$toast.success('删除成功')
              const index = this.form.products.findIndex(
                (x) => x.id === item.id
              )
              this.form.products.splice(index, 1)
              this.computeSum()
            }
          })
        }
      })
    },
    newProductFinish(product) {
      this.form.products.push(product)
      this.computeSum()
    },
    computeSum() {
      const sum = numeral(0)
      this.form.products.forEach((item) => {
        sum.add(item.sum)
      })
      this.form.sum = sum.value()
    },
    updateProductFinish(product) {
      const index = this.form.products.findIndex((x) => x.id === product.id)
      this.$set(this.form.products, index, product)
      this.computeSum()
    },
    fileUploadClick() {
      this.$refs.fileUpload.click()
    },
    fileUpload() {
      this.progress = 0
      const file = this.$refs.fileUpload.files[0]
      const formData = new FormData()
      formData.append('file', file)
      backend(api.order.fileUpload, formData, (progressEvent) => {
        if (progressEvent.lengthComputable) {
          this.progress = parseInt(
            (progressEvent.loaded / progressEvent.total) * 100
          )
        }
      }).then((result) => {
        if (result.statusCode === 200) {
          this.form.cadFile = result.data.cadFile
          this.form.cadFileName = result.data.cadFileName
          this.$toast.success('上传成功')
        }
      })
    },
    addToDesign(product) {
      const img = new Image()
      img.src = product.pic
      const scale = 200 / img.naturalWidth
      fabric.Image.fromURL(product.pic, (img) => {
        const oImg = img
          .set({
            left: 10,
            top: 10,
            angle: 0,
            hasRotatingPoint: false
          })
          .scale(scale)
        canvas.add(oImg).renderAll()
        canvas.setActiveObject(oImg)
        canvas.renderAll()
      })
    },
    mm2px(mm) {
      return parseFloat(mm) * 3.779527
    },
    betterScrollInit() {
      scroll = new BScroll(this.$refs.scroll, {
        scrollX: true,
        scrollY: false,
        click: false,
        momentum: false,
        snap: true,
        snapLoop: true,
        snapThreshold: 0,
        snapSpeed: 400,
        scrollbar: false,
        probeType: 1,
        disableMouse: true
      })
    },
    fabricInit() {
      const self = this
      if (canvas === null) {
        canvas = new fabric.Canvas('canvas')
        canvas.on('after:render', () => {
          self.saveFabric()
        })
      } else {
        canvas.setHeight(this.mm2px(220 - this.form.products.length * 6))
      }
      canvas.clear()
      if (this.form.pdfData.length > 0) {
        canvas.loadFromJSON(canvasData, () => {
          canvas.renderAll()
        })
      }
    },
    saveFabric() {
      canvasData = canvas.toJSON()
      this.form.pdfData = canvas.toObject().objects
    },
    submit() {
      if (this.form.customer.id === undefined) {
        this.$toast.error('请选择客户')
        return
      } else if (this.form.products.length === 0) {
        this.$toast.error('请添加产品')
        return
      } else if (this.form.cadFile === '') {
        this.$toast.error('请上传文件')
        return
      }
      this.submitLoading = true
      backend(api.order.create, this.form).then((result) => {
        this.submitLoading = false
        if (result.statusCode === 200) {
          this.$toast.success('下单成功')
          window.open(result.data.pdfFile, '_blank')
          // this.form = {
          //   customerStr: '',
          //   customer: {},
          //   products: [],
          //   pdfData: [],
          //   sum: 0,
          //   cadFile: '',
          //   cadFileName: ''
          // }
          // canvasData = null
          // this.activeStep = 0
          // this.changeFileName(result.data)
        }
      })
    },
    changeFileName(order) {
      backend(api.order.changeFileNameLocal, order).then((result) => {
        if (result.statusCode === 200) {
          backend(api.order.changeFileName, result.data)
        }
      })
    },
    canvasReset() {
      canvas.clear()
      canvasData = null
    }
  },
  mounted() {
    // this.getAllCustomer()
    this.betterScrollInit()
    this.getOrderData()
  },
  watch: {
    activeStep(val) {
      scroll.goToPage(val, 0, 1000)
      if (val === 1 && this.form.products.length === 0) {
        this.productOpen = true
      } else if (val === 2) {
        this.fabricInit()
      }
    },
    $route(val) {
      if (val.name === '订单修改') {
        this.getOrderData()
      }
    }
  }
}
</script>

<style lang="less">
.edit-order {
  display: flex;
  flex-direction: column;
  .step {
    display: flex;
    height: 72px;
    .prev-step,
    .next-step {
      flex: 0 0 106px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .stepper {
      flex: 1;
    }
  }
  .step-wrapper {
    flex: 1;
    overflow: hidden;
    position: relative;
    .scroll-wrapper {
      height: 100%;
      width: 500%;
      white-space: nowrap;
      .step-content {
        width: 20%;
        height: 100%;
        float: left;
        display: flex;
        border: 1px solid #ddd;
        box-sizing: border-box;
        &.customer {
          justify-content: center;
          .form {
            width: 360px;
          }
        }
        &.product {
          position: relative;
          overflow-y: auto;
          .add-button {
            position: absolute;
            bottom: 30px;
            right: 30px;
            z-index: 9;
            cursor: pointer;
          }
          .table {
            width: 100%;
            overflow-y: auto;
          }
        }
        &.design {
          .img-wrapper {
            flex: 0 0 30%;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            .title {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              line-height: 40px;
              text-align: center;
              background: #fff;
            }
            .img-list {
              overflow-y: auto;
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              padding: 20px 0;
              .img-item {
                margin-top: 10px;
                cursor: pointer;
                border: 1px solid #ddd;
                border-radius: 4px;
                width: 210px;
                height: 210px;
                display: flex;
                justify-content: center;
                align-items: center;
                &:first-child {
                  margin-top: 50px;
                }
              }
            }
          }
          .canvas-wrapper {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;
            padding: 10px 0;
            box-sizing: border-box;
            .canvas-reset {
              position: absolute;
              top: 20px;
              right: 20px;
            }
            .title {
              flex: 0 0 40px;
              line-height: 40px;
              text-align: center;
              background: #fff;
              z-index: 9;
            }
            .canvas {
              flex: 1;
              overflow-x: hidden;
              overflow-y: scroll;
              display: flex;
              .canvas-container {
                border: 1px solid #ddd;
              }
            }
          }
        }
        &.file {
          justify-content: center;
          align-items: center;
          .progress {
            margin: 20px 0;
          }
          .file-upload {
            display: none;
          }
        }
        &.complete {
          flex-direction: column;
          align-items: center;
          overflow-y: auto;
          padding-bottom: 50px;
          .info {
            width: 600px;
            margin-top: 60px;
            padding: 20px 0;
            .info-item {
              display: flex;
              line-height: 32px;
              .title {
                flex: 0 0 120px;
                text-align: right;
              }
              .desc {
                flex: 1;
                margin-left: 10px;
              }
            }
            .product-table {
              width: 90%;
              margin: 0 auto;
              table {
                width: 100%;
                margin: 10px 0;
                tr {
                  line-height: 30px;
                  border-bottom: 1px solid #ddd;
                  th,
                  td {
                    text-align: center;
                  }
                }
              }
            }
          }
          .submit-button {
            margin-top: 40px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order/editOrder.vue